import { AVAILABLE_LANGS } from "@typings/globals";

export const createHref = (language: AVAILABLE_LANGS, link: string): string =>
  `/${language}${link}`;
